import React, { useState, useEffect, useRef } from "react";
import PageHeader from "../../Components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import { FaTimes } from "react-icons/fa";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";
import "./NotificationAdd.css";
import { get, post } from "../../Services/ApiHandler";
import { URLS } from "../../Services/Constant";
// /import { toast } from "react-toastify";
import { toast } from "react-hot-toast";
import Header from "../../Components/Header";
import { leftArrow } from "../../common/Assets/imgs";

const PushNotificationAdd = () => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("location", location);
  // const {typee} = location?.state?.type;
  // console.log('type',type);

  const { data, mode, page, type } = location.state || {};
  const isViewMode = mode === "view";

  // const [userType, setUserType] = useState("all"); // 'all' or 'specific'
  const [userType, setUserType] = useState(""); // 'all' or 'specific'
  const [heading, setHeading] = useState("");
  const [notification, setNotification] = useState("");
  const [searchUser, setSearchUser] = useState("");
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [selectedDrivers, setSelectedDrivers] = useState([]);
  const [selectedTransports, setSelectedTransports] = useState([]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [userList, setUserList] = useState([]);
  const [permissionList, setPermissionList] = useState([]);
  const dropdownRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);

  const normalizeSendTo = (value) => {
    if (!value) return "";
    const raw = String(value).trim();
    const lowered = raw.toLowerCase();

    const normalizedMap = {
      "all users": "all_users",
      "all user": "all_users",
      all_users: "all_users",
      all_user: "all_users",
      "all transport owners": "all_transport",
      "all transport owner": "all_transport",
      all_transport_owner: "all_transport",
      all_transport_owners: "all_transport",
      all_transport: "all_transport",
      "all drivers": "all_drivers",
      "all driver": "all_drivers",
      all_driver: "all_drivers",
      all_drivers: "all_drivers",
      overall: "overall",
      overall_users: "overall",
      "specific users": "specific_users",
      "specific user": "specific_users",
      specific_users: "specific_users",
      specific_user: "specific_users",
      "specific transport owner": "specific_transport",
      "specific transport owners": "specific_transport",
      specific_transport_owner: "specific_transport",
      specific_transport_owners: "specific_transport",
      specific_transport: "specific_transport",
      "specific driver": "specific_drivers",
      "specific drivers": "specific_drivers",
      specific_driver: "specific_drivers",
      specific_drivers: "specific_drivers",
    };

    return normalizedMap[lowered] || raw;
  };

  const resolveSendTo = (source) => {
    if (!source) return "";
    if (source?.send_to) return normalizeSendTo(source.send_to);
    if (source?.is_all_users === true) return "all_users";
    if (source?.is_all_transport === true) return "all_transport";
    if (source?.is_all_drivers === true) return "all_drivers";
    if (source?.is_overall === true) return "overall";
    if (Array.isArray(source?.users) && source.users.length > 0) {
      return "specific_users";
    }
    if (
      (Array.isArray(source?.drivers) && source.drivers.length > 0) ||
      (Array.isArray(source?.driver_ids) && source.driver_ids.length > 0)
    ) {
      return "specific_drivers";
    }
    if (
      (Array.isArray(source?.transports) && source.transports.length > 0) ||
      (Array.isArray(source?.transport_ids) &&
        source.transport_ids.length > 0) ||
      (Array.isArray(source?.transport_owners) &&
        source.transport_owners.length > 0)
    ) {
      return "specific_transport";
    }
    if (
      source?.is_all_users === false &&
      (Array.isArray(source?.users) ? source.users.length === 0 : true) &&
      (Array.isArray(source?.drivers) ? source.drivers.length === 0 : true) &&
      (Array.isArray(source?.transports) ? source.transports.length === 0 : true)
    ) {
      return "overall";
    }
    return "";
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // useEffect(() => {
  //   if (data) {
  //     setHeading(data?.title || data?.description || "");
  //     setNotification(data?.description || "");
  //     setUserType(data?.send_to || "all_users");

  //     if (data?.send_to === "specific_users") {
  //       setSelectedUsers(data?.users || []);
  //     }

  //     if (data?.send_to === "specific_drivers") {
  //       setSelectedDrivers(data?.drivers || []);
  //     }

  //     if (data?.send_to === "specific_transport") {
  //       setSelectedTransports(data?.transports || []);
  //     }
  //   }
  // }, [data]);

  //   useEffect(() => {
  //   if (mode === "view" && data?.id) {
  //     fetchNotificationDetail(data.id);
  //   }
  // }, [data, mode]);

  // useEffect(() => {
  //   if (data && userList.length > 0) {
  //     setHeading(data?.title || data?.description || "");
  //     setNotification(data?.description || "");
  //     setUserType(data?.send_to || "all_users");

  //     if (data?.send_to === "specific_users") {
  //       const selected = userList.filter(user =>
  //         (data?.users || []).some(u => u.id === user.id)
  //       );
  //       setSelectedUsers(selected);
  //     }

  //     if (data?.send_to === "specific_drivers") {
  //       const selected = userList.filter(user =>
  //         (data?.drivers || []).some(d => d.id === user.id)
  //       );
  //       setSelectedDrivers(selected);
  //     }

  //     if (data?.send_to === "specific_transport") {
  //       const selected = userList.filter(user =>
  //         (data?.transports || []).some(t => t.id === user.id)
  //       );
  //       setSelectedTransports(selected);
  //     }
  //   }
  // }, [data, userList]);

//   useEffect(() => {
//   if (data) {
//     setHeading(data?.title || data?.description || "");
//     setNotification(data?.description || "");
//     setUserType(data?.send_to || "all_users");

//     if (data?.send_to === "specific_users") {
//       setSelectedUsers(data?.users || []);
//     }

//     if (data?.send_to === "specific_drivers") {
//       setSelectedDrivers(data?.drivers || []);
//     }

//     if (data?.send_to === "specific_transport") {
//       setSelectedTransports(data?.transports || []);
//     }
//   }
// }, [data]);

  useEffect(() => {
    if (!data) return;

    setHeading(data?.title || data?.description || "");
    setNotification(data?.description || "");

    const sendTo = resolveSendTo(data);
    if (sendTo) {
      setUserType(sendTo);
    }

    if (sendTo === "specific_users") {
      setSelectedUsers(data?.users || []);
    }

    if (sendTo === "specific_drivers") {
      setSelectedDrivers(data?.drivers || []);
    }

    if (sendTo === "specific_transport") {
      setSelectedTransports(data?.transports || []);
    }
  }, [data]);

  const filteredUsers = (userList || []).filter((user) =>
    user?.name?.toLowerCase().includes((searchUser || "").toLowerCase()),
  );

  const getSelectedList = () => {
    if (userType === "specific_users") return selectedUsers;
    if (userType === "specific_drivers") return selectedDrivers;
    if (userType === "specific_transport") return selectedTransports;
    return [];
  };

  const setSelectedList = (list) => {
    if (userType === "specific_users") setSelectedUsers(list);
    if (userType === "specific_drivers") setSelectedDrivers(list);
    if (userType === "specific_transport") setSelectedTransports(list);
  };

  // const handleUserSelect = (user) => {
  //   if (isViewMode || !user) return;
  //   const isSelected = selectedUsers.some(
  //     (selected) => selected.id === user.id,
  //   );
  //   if (isSelected) {
  //     setSelectedUsers(
  //       selectedUsers.filter((selected) => selected.id !== user.id),
  //     );
  //   } else {
  //     setSelectedUsers([...selectedUsers, user]);
  //   }
  // };

  const handleUserSelect = (user) => {
    if (isViewMode || !user) return;

    const list = getSelectedList();
    const isSelected = list.some((s) => s.id === user.id);

    const updated = isSelected
      ? list.filter((s) => s.id !== user.id)
      : [...list, user];

    setSelectedList(updated);
  };

  const handleSelectAll = () => {
    if (isViewMode) return;

    const list = getSelectedList();

    const allSelected = filteredUsers.every((user) =>
      list.some((s) => s.id === user.id),
    );

    let updated;
    if (allSelected) {
      updated = list.filter((s) => !filteredUsers.some((u) => u.id === s.id));
    } else {
      updated = [...list];
      filteredUsers.forEach((user) => {
        if (!updated.some((s) => s.id === user.id)) {
          updated.push(user);
        }
      });
    }

    setSelectedList(updated);
  };

  const handleRemoveUser = (id) => {
    if (isViewMode) return;

    const list = getSelectedList();
    setSelectedList(list.filter((item) => item.id !== id));
  };

  const handleSubmit = async () => {
    // if (!heading || !notification) {
    //   toast.error("Please fill in all required fields");
    //   return;
    // }
    if (!heading?.trim()) {
      toast.error("Please enter heading");
      return;
    }

    if (!notification?.trim()) {
      toast.error("Please enter notification");
      return;
    }

    if (userType === "specific_users" && getSelectedList().length === 0) {
      toast.error("Please select at least one user");
      return;
    }

    if (userType === "specific_drivers" && getSelectedList().length === 0) {
      toast.error("Please select at least one driver");
      return;
    }

    if (userType === "specific_transport" && getSelectedList().length === 0) {
      toast.error("Please select at least one transport");
      return;
    }

    const datasid = {
      driver_ids:
        userType === "specific_drivers"
          ? getSelectedList().map((d) => d?.id)
          : [],

      transport_ids:
        userType === "specific_transport"
          ? getSelectedList().map((t) => t?.id)
          : [],

      user_ids:
        userType === "specific_users"
          ? getSelectedList().map((u) => u?.id)
          : [],
    };

    const payload = {
      send_to: userType,
      title: heading,
      description: notification,
      ...datasid,
    };
    console.log("Notification Payload:", payload);

    try {
      setIsLoading(true);
      let res = await post(URLS.PUSH_NOTIFICATION_ADD, payload);
      // let res = await post(URLS.PUSHNOTIFICATION, payload);
      if (res?.status === "success") {
        toast.success(res?.message || "Notification sent successfully");
        setHeading("");
        setNotification("");
        setSelectedUsers([]);
        setSelectedDrivers([]);
        setSelectedTransports([]);
        setSearchUser("");
        navigate("/push-notification", { state: { page: page || 1 } });
      } else {
        toast.error(res?.message || "Failed to send notification");
      }
    } catch (error) {
      console.error("Error sending notification:", error);
      toast.error(error?.message || "Failed to send notification");
    } finally {
      setIsLoading(false);
    }
  };

  // const handlePushNotification = async () => {
  //   try {

  //     let res = await get(URLS.USER_MANAGEMENT_LIST);
  //     // let res = await get(URLS.USERLIST_DROPDOWN);
  //     if (res?.status === "success") {
  //       setUserList(res?.data || []);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user list:", error);
  //   }
  // };
  const getSearchLabel = () => {
    if (userType === "specific_users") return "Search User";
    if (userType === "specific_drivers") return "Search Driver";
    if (userType === "specific_transport") return "Search Transport Owner";
    return "Search";
  };

  const handlePushNotification = async () => {
    try {
      let res;
      if (userType === "specific_users") {
        res = await get(URLS.USER_MANAGEMENT_LIST);
      } else if (userType === "specific_drivers") {
        res = await get(URLS.PUSH_NOTIFICATION_DRIVER_LIST);
      } else if (userType === "specific_transport") {
        res = await get(URLS.PUSH_NOTIFICATION_TRANSPORT_LIST);
      } else {
        return;
      }
      if (res?.status === "success") {
        setUserList(res?.data || []);
      }
    } catch (error) {
      console.log("error fetching user list", error);
    }
  };

  useEffect(() => {
    handlePushNotification();
  }, [userType]);

  // useEffect(() => {
  //   setSelectedUsers([]);
  //   setSelectedDrivers([]);
  //   setSelectedTransports([]);
  //   setSearchUser("");
  //   setShowDropdown(false);
  // }, [userType]);

  //   useEffect(() => {
  //   if (!isViewMode) {
  //     setSelectedUsers([]);
  //     setSelectedDrivers([]);
  //     setSelectedTransports([]);
  //     setSearchUser("");
  //     setShowDropdown(false);
  //   }
  // }, [userType]);

  console.log("handlePushNotification", userList);

  return (
    <>
      <Header />
      <div
        style={{ marginTop: "7rem", paddingLeft: "10px", paddingRight: "10px" }}
      >
        <div onClick={() => navigate(-1)} className="admin-header mb-0">
          <img src={leftArrow} className="back-icon-arrow" />
          <h2>Push Notification</h2>
        </div>

        {/* <PageHeader
        title={isViewMode ? "View Notification" : "Push Notifications"}
        showBackButton={true}
        onBackClick={() =>
          navigate("/notifications", { state: { page: page || 1 } })
        }
        
      /> */}

        <div className="notification-add-container">
          <div className="notification-add-form">
            {/* User Type Selection */}
            <div
              className="user-type-section"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              {/* <div className="radio-group">
              <label
                className={`radio-option ${
                  userType === "all" ? "active" : ""
                } ${isViewMode ? "disabled" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="all"
                  checked={userType === "all"}
                  onChange={(e) => setUserType(e.target.value)}
                  disabled={isViewMode}
                />
                <span className="radio-label">All Users</span>
              </label>
              <label
                className={`radio-option ${
                  userType === "specific" ? "active" : ""
                } ${isViewMode ? "disabled" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="specific"
                  checked={userType === "specific"}
                  onChange={(e) => setUserType(e.target.value)}
                  disabled={isViewMode}
                />
                <span className="radio-label">Specific Users</span>
              </label>
              <label
                className={`radio-option ${
                  userType === "specific" ? "active" : ""
                } ${isViewMode ? "disabled" : ""}`}
              >
                <input
                  type="radio"
                  name="userType"
                  value="specific"
                  checked={userType === "specific"}
                  onChange={(e) => setUserType(e.target.value)}
                  disabled={isViewMode}
                />
                <span className="radio-label">Specific Users</span>
              </label>
            </div> */}

              <div className="radio-group multi-radio">
                {[
                  { label: "All Users", value: "all_users" },
                  { label: "All Transport Owners", value: "all_transport" },
                  { label: "All Drivers", value: "all_drivers" },
                  { label: "Overall", value: "overall" },
                  { label: "Specific Users", value: "specific_users" },
                  {
                    label: "Specific Transport Owner",
                    value: "specific_transport",
                  },
                  { label: "Specific Driver", value: "specific_drivers" },
                ]
                  .filter((item) =>
                    !isViewMode ? true : item.value === userType,
                  )
                  .map((item) => (
                  <label
                    key={item.value}
                    className={`radio-option ${
                      userType === item.value ? "active" : ""
                    } ${isViewMode ? "disabled" : ""}`}
                  >
                    <input
                      type="radio"
                      name="userType"
                      value={item.value}
                      checked={userType === item.value}
                      // onChange={(e) => setUserType(e.target.value)}
                      onChange={(e) => {
                        if (!isViewMode) {
                          setUserType(e.target.value);

                          // reset only when user changes manually
                          setSelectedUsers([]);
                          setSelectedDrivers([]);
                          setSelectedTransports([]);
                          setSearchUser("");
                          setShowDropdown(false);
                        }
                      }}
                      disabled={isViewMode}
                    />
                    <span className="radio-label">{item.label}</span>
                  </label>
                ))}
              </div>

              {/* Search User Dropdown - Only show when Specific Users is selected */}
            </div>
            {/* {userType === "specific" && ( */}
            {[
              "specific_users",
              "specific_transport",
              "specific_drivers",
            ].includes(userType) && (
              <div className="search-user-section mb-3">
                {!isViewMode && <label>{getSearchLabel()}</label>}
                {!isViewMode && (
                  <div className="search-dropdown-wrapper" ref={dropdownRef}>
                    <input
                      type="text"
                      className="search-user-input"
                      placeholder={getSearchLabel()}
                      value={searchUser || ""}
                      onChange={(e) => {
                        setSearchUser(e.target.value);
                        setShowDropdown(true);
                      }}
                      onFocus={() => setShowDropdown(true)}
                    />
                    {showDropdown && (
                      <div className="user-dropdown">
                        {(filteredUsers || []).length > 0 && (
                          <div
                            className="user-dropdown-item select-all-item"
                            onClick={handleSelectAll}
                            style={{
                              fontWeight: "bold",
                              borderBottom: "1px solid #eee",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            Select All
                            {filteredUsers.every((user) =>
                              getSelectedList().some((s) => s.id === user.id),
                            ) ? (
                              <CheckCircleIcon
                                style={{ color: "green", marginRight: "10px" }}
                              />
                            ) : (
                              <RadioButtonUncheckedIcon
                                style={{ color: "gray", marginRight: "10px" }}
                              />
                            )}
                          </div>
                        )}
                        {(filteredUsers || []).length > 0 ? (
                          filteredUsers.map((user) => {
                            const isSelected = getSelectedList().some(
                              (s) => s.id === user.id,
                            );
                            return (
                              <div
                                key={user?.id}
                                className="user-dropdown-item"
                                onClick={() => handleUserSelect(user)}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                }}
                              >
                                {user?.name || "Unknown"}
                                {isSelected ? (
                                  <CheckCircleIcon
                                    style={{
                                      color: "green",
                                      marginRight: "10px",
                                    }}
                                  />
                                ) : (
                                  <RadioButtonUncheckedIcon
                                    style={{
                                      color: "gray",
                                      marginRight: "10px",
                                    }}
                                  />
                                )}
                              </div>
                            );
                          })
                        ) : (
                          <div className="user-dropdown-item">
                            No users found
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                )}

                {/* Selected Users List */}
                {(getSelectedList() || []).length > 0 && (
                  <div className="selected-users-list">
                    {getSelectedList().map((user) => (
                      <div key={user?.id} className="selected-user-item">
                        <span>{user?.name || "Unknown"}</span>
                        {!isViewMode && (
                          <FaTimes
                            className="remove-user-icon"
                            onClick={() => handleRemoveUser(user?.id)}
                          />
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* Heading */}
            <div className="form-group">
              <label>Heading</label>
              <input
                type="text"
                value={heading || ""}
                onChange={(e) => setHeading(e.target.value)}
                placeholder="Notification Heading!"
                disabled={isViewMode}
              />
            </div>

            {/* Notification */}
            <div className="form-group">
              <label>Notification</label>
              <textarea
                value={notification || ""}
                onChange={(e) => setNotification(e.target.value)}
                placeholder="Message!"
                rows={4}
                disabled={isViewMode}
              />
            </div>

            {/* Action Buttons */}

            <div className="form-actions">
              <button
                type="button"
                className="btn-edit"
                onClick={() =>
                  navigate("/push-notification", {
                    state: { page: page || 1 },
                  })
                }
              >
                Back
              </button>

              {/* {type === "add" && ( */}
              {!isViewMode && (
                <button
                  type="button"
                  className="btn-submit"
                  onClick={handleSubmit}
                >
                  {/* Submit */}
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                        style={{ color: "white", padding: 8 }}
                      ></span>
                    </>
                  ) : (
                    "Submit"
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PushNotificationAdd;
